import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { MapServicesModal } from './MapServicesModal';
export const useOpenMapServicesModal = (serviceTemplateIds, reload)=>{
    const overlayContext = useOverlayContext();
    const { t: commonTexts } = useLocaleKeys('common');
    return async function openMapServicesModal(accounting) {
        if (!serviceTemplateIds.length) {
            overlayContext.showErrorToast(commonTexts.toasts.anErrorOccurred(), 'no-services-to-map-toast');
            return;
        }
        await overlayContext.showModal({
            biName: 'map_services_modal',
            closeOnClickOutside: false,
            closeOnEscapeKey: false,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(MapServicesModal, {
                    accounting: accounting,
                    dismissModal: dismissModal,
                    serviceTemplateIds: serviceTemplateIds,
                    onChange: reload
                });
            }
        });
    };
};
